import { getMonthIndex } from './../../utils/getMonthIndex'

const calculateTotal = (monthData) => {
    const total = {
        projectCount: 0,
        workspaceCount: 0,
        withX: false
    };

    ['sout', 'pk', 'opr'].forEach(type => {
        
        if (monthData[type] && (monthData[type].projectsCount > 0 || monthData[type].workspaceCount > 0)) {
            total.projectCount += monthData[type].projectsCount || 0;
            total.workspaceCount += monthData[type].workspaceCount || 0;
            total.withX = total.withX || monthData[type].withX || false;
        }

    });

    return total;
};


const processWorkloadData = (project, monthHeaders) => {
    const allMonthsData = {};
    const allStages = [
        // project?.waitingForRequest,
        project?.informationCollection,
        project?.readyToWork,
        project?.acceptedToWork,
    ];

    allStages.forEach(stage => {
        if (!stage?.byDates) return;

        stage.byDates.forEach(item => {
            const monthKey = `${item.year}-${item.month}`;

            if (!allMonthsData[monthKey]) {
                allMonthsData[monthKey] = {
                    year: item.year,
                    month: item.month,
                    sout: { projectsCount: 0, workspaceCount: 0, withX: false },
                    pk: { projectsCount: 0, workspaceCount: 0, withX: false },
                    opr: { projectsCount: 0, workspaceCount: 0, withX: false }
                };
            }

            ['sout', 'pk', 'opr'].forEach(type => {
                if (item[type]) {
                    allMonthsData[monthKey][type].projectsCount += item[type].projectsCount || 0;
                    allMonthsData[monthKey][type].workspaceCount += item[type].workspaceCount || 0;
                    allMonthsData[monthKey][type].withX = allMonthsData[monthKey][type].withX || item[type].withX;
                }
            });
        });
    });

    const totalData = {
        sout: { projectsCount: 0, workspaceCount: 0, withX: false },
        pk: { projectsCount: 0, workspaceCount: 0, withX: false },
        opr: { projectsCount: 0, workspaceCount: 0, withX: false }
    };

    const monthsColumns = monthHeaders.map(([monthHeader], i) => {
        const [monthName, year] = monthHeader.split('/');
        const monthKey = `${year}-${getMonthIndex(monthName)}`;
        const monthData = allMonthsData[monthKey];

        if (monthData) {
            delete allMonthsData[monthKey];

            const total = calculateTotal(monthData);

            return {
                type: 'month',
                key: i,
                data: {
                    total,
                    sout: monthData.sout?.projectsCount ? monthData.sout : null,
                    pk: monthData.pk?.projectsCount ? monthData.pk : null,
                    opr: monthData.opr?.projectsCount ? monthData.opr : null,
                    datesCount: null,
                    containsX: total.withX
                }
            };
        } else {
            return { type: 'empty', key: i };
        }
    });


    const otherMonths = Object.values(allMonthsData);
    const otherData = {
        sout: { projectsCount: 0, workspaceCount: 0, withX: false },
        pk: { projectsCount: 0, workspaceCount: 0, withX: false },
        opr: { projectsCount: 0, workspaceCount: 0, withX: false }
    };

    otherMonths.forEach(month => {
        ['sout', 'pk', 'opr'].forEach(type => {
            if (month[type]) {
                otherData[type].projectsCount += month[type].projectsCount || 0;
                otherData[type].workspaceCount += month[type].workspaceCount || 0;
                otherData[type].withX = otherData[type].withX || month[type].withX;

                totalData[type].projectsCount += month[type].projectsCount || 0;
                totalData[type].workspaceCount += month[type].workspaceCount || 0;
                totalData[type].withX = totalData[type].withX || month[type].withX;
            }
        });
    });

    const hasOtherData = ['sout', 'pk', 'opr'].some(type =>
        otherData[type].projectsCount > 0 || otherData[type].workspaceCount > 0
    );

    const plus7Month = {
        type: 'plus7',
        data: hasOtherData ? {
            total: {
                projectsCount: ['sout', 'pk', 'opr'].reduce((sum, type) =>
                    sum + (otherData[type]?.projectsCount || 0), 0),
                workspaceCount: ['sout', 'pk', 'opr'].reduce((sum, type) =>
                    sum + (otherData[type]?.workspaceCount || 0), 0),
                withX: ['sout', 'pk', 'opr'].some(type => otherData[type]?.withX)
            },
            sout: otherData.sout,
            pk: otherData.pk,
            opr: otherData.opr,
            datesCount: null,
            containsX: otherData.total?.withX
        } : null
    };

    return {
        monthsColumns,
        plus7Month,
    };
};


export default processWorkloadData